export default {
  eyebrow: 'Manage',
  title: 'Settings',
  description: 'Company-wide settings for this tenant.',
  passcodeSaved: 'Unpair passcode saved.',
  passcodeRemoved: 'Unpair passcode removed.',
  passcodeTitle: 'Device unpair passcode',
  passcodeDescription: 'Required to unpair an employee\'s phone from the Employees page. Employees can\'t unpair their own phone from the CrewPresence app — only an admin who knows this passcode can.',
  passcodeIsSet: 'A passcode is currently set for this company.',
  passcodeNotSet: 'No passcode is set — devices cannot be unpaired until one is set.',
  replacePasscode: 'Replace passcode',
  setPasscode: 'Set passcode',
  passcodeHint: '4-10 digits.',
  passcodePlaceholder: 'e.g. 4471',
  removePasscode: 'Remove passcode',
  savePasscode: 'Save passcode',
  logoHint: 'PNG with a transparent background works best. Shown to your crew in the CrewPresence app.',
  entraKindCreate: 'New',
  entraKindUpdate: 'Updated',
  entraKindDeactivate: 'Deactivate',
  entraKindLinkUser: 'Linked',
  entraDescription: 'Import people, job titles and reporting lines from Microsoft Entra ID, and let portal users sign in with their Microsoft account. Uses your own Azure app registration, so nothing is shared with other companies.',
  entraSaved: 'Office 365 settings saved.',
  entraHowTo: 'How to set up the Azure app registration',
  entraStep1: 'In the Azure portal open Microsoft Entra ID → App registrations → New registration.',
  entraStep2: 'Add a <b>Web</b> redirect URI: <uri>{redirectUri}</uri>',
  entraStep3: 'Under API permissions add Microsoft Graph → <b>Application</b> permission <code>User.Read.All</code>, then grant admin consent. (Sign-in only uses the delegated <code>openid profile email</code> scopes.)',
  entraStep4: 'Under Certificates & secrets create a client secret and paste its <b>value</b> below, along with the tenant ID and application (client) ID from the Overview page.',
  entraTenantId: 'Tenant ID',
  entraTenantIdHint: 'Directory (tenant) ID, or your primary domain.',
  entraClientId: 'Client ID',
  entraClientIdHint: 'Application (client) ID.',
  entraClientSecret: 'Client secret',
  entraSecretStoredHint: 'A secret is stored. Leave blank to keep it, or paste a new one to replace it.',
  entraSecretHint: 'Paste the secret value (not the secret ID).',
  entraSyncNightly: 'Sync people from Office 365 every night',
  entraAllowSignIn: 'Allow “Sign in with Microsoft” for portal users',
  entraRemoveConnection: 'Remove connection',
  entraDirectorySync: 'Directory sync',
  entraLastSyncOk: 'Last sync OK',
  entraLastSyncFailed: 'Last sync failed',
  entraNeverSynced: 'Never synced',
  entraSyncExplainer: 'Matches people by Microsoft ID, then by email. Creates and updates employees, sets managers when the person\'s Microsoft manager is already a portal admin or site manager, and deactivates employees who leave the directory. Employees you added by hand are never deactivated.',
  entraConnected: 'Connected to Microsoft Graph.',
  entraTesting: 'Testing…',
  entraTestConnection: 'Test connection',
  entraChecking: 'Checking…',
  entraPreviewSync: 'Preview sync',
  entraSyncComplete: 'Sync complete: {created} created, {updated} updated.',
  entraRemoveTitle: 'Remove Office 365 connection',
  entraRemoveMessage: 'The stored credentials are deleted and the nightly sync and Microsoft sign-in stop working. Employees already imported are kept.',
  entraRemoved: 'Office 365 connection removed.',
  entraUpToDate: 'Everything is already up to date.',
  entraPreviewHeading: 'This is what a sync would change:',
  entraPreviewSummary: '{users} directory users · {created} new · {updated} updated · {deactivated} to deactivate · {managers} manager links · {linked} portal users linked',
  entraTruncated: 'Only the first {count} changes are listed; all of them are applied.',
  entraDiscard: 'Discard',
  entraApplying: 'Applying…',
  entraApplyChanges: 'Apply changes',
  inductSafeDescription: 'Optional: check induction status before treating a geofence entry as valid presence, and report check-ins/check-outs to InductSafe. Never blocks your own presence tracking if InductSafe is unreachable or someone isn\'t inducted yet.',
  inductSafeSaved: 'InductSafe settings saved.',
  inductSafeEnabled: 'Report presence to InductSafe',
  inductSafeBaseUrl: 'InductSafe URL',
  inductSafeBaseUrlHint: 'Your InductSafe tenant\'s web address.',
  inductSafeApiKey: 'API key',
  inductSafeApiKeyStoredHint: 'A key is stored. Leave blank to keep it, or paste a new one to replace it.',
  inductSafeApiKeyHint: 'Create one under API keys in your InductSafe admin settings.',
  inductSafeRemoveConnection: 'Remove connection',
  inductSafeRemoveTitle: 'Remove InductSafe connection',
  inductSafeRemoveMessage: 'The stored API key is deleted and presence reporting stops. Nothing already sent to InductSafe is affected.',
  inductSafeRemoved: 'InductSafe connection removed.',
  inductSafeLastCallOk: 'Last call OK',
  inductSafeLastCallFailed: 'Last call failed',
  inductSafeNeverCalled: 'No calls yet',
  inductSafeSitesTitle: 'Site link status',
  inductSafeSiteColumn: 'Site',
  inductSafeSitesCaption: 'Sites are linked to InductSafe over there, not here. Status shown reflects the last real check-in attempt for that site, not a live check, so a site shows "Unknown" until it has had one.',
  inductSafeSiteLinked: 'Linked',
  inductSafeSiteNotLinked: 'Not linked',
  inductSafeSiteUnknown: 'Unknown',
  languageTitle: 'Company language',
  languageDescription: 'Used for emails, app notifications and the portal for anyone who hasn’t picked their own language.',
  languageSaved: 'Company language saved.',
}
